import { Chip, Link } from "@material-ui/core";
import React, { useContext } from "react";
import { Link as RouterLink } from "react-router-dom";

import { FullSite } from "../../../../dtos/site";
import { useForceRerender } from "../../../../hooks/useForceRerender";
import SignalRContext from "../../../../signalr/context";

interface Props {
    site: FullSite;
    dealerId: number | null;
}

export function SiteRoomAlarmIndicator({
    site,
    dealerId,
}: Props) {
    // The `alarmStatus` map reference does not change when new data is received,
    // so this component will not re-render automatically.
    useForceRerender(2000);

    const { alarmStatus } = useContext(SignalRContext);
    const dynamicAlarm = alarmStatus.get(site.id);
    const isAlarmActive = dynamicAlarm !== undefined ? dynamicAlarm : site.activeAlarm;

    return (
        <Link
            component={RouterLink}
            to={{
                pathname: `/dealers/${dealerId}/organizations/${site.organizationId}/sites/${site.id}/alarms`,
                state: {
                    // Pass null date filters to show ALL alarms (not just last 30 days)
                    // and only show unacknowledged alarms
                    from: null,
                    to: null,
                    showOnlyUnacknowledged: true,
                }
            }}
        >
            {isAlarmActive
                ? (
                    <Chip
                        variant="outlined"
                        color="secondary"
                        label="Active Alarm"
                    />
                )
                : (
                    <Chip
                        variant="outlined"
                        color="primary"
                        label="No alarms"
                    />
                )
            }
        </Link>
    );
}
